import { Component, AfterViewInit, ViewChild, ElementRef, OnInit, Output, EventEmitter, ViewContainerRef, Input, TemplateRef, ViewChildren, QueryList, ComponentFactoryResolver } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { OutputformatService } from '../../../Master/outputformat/outputformat.service';
import { DtdService } from '../../../Master/dtd/dtd.service';
import { Dtd } from '../../../Master/dtd/dtd';
import { Outputformat } from '../../../Master/outputformat/outputformat';
import { TypeService } from '../../../Master/type/type.service';
import { Type } from '../../../Master/type/type';
import { BsDatepickerConfig, BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap';
import { CommondialogComponent } from '../../../Shared/commondialog/commondialog.component';
import { DialogService } from 'ng2-bootstrap-modal';
import { ConversionrequestDetail, ConversionrequestFileDetail } from '../requestconfig';
import { DatePipe } from '@angular/common';
import { RequestconfigService } from '../requestconfig.service';
import { ToastrService } from 'ngx-toastr';
import { productDatacontainerDirective } from '../requestconfig.component';
import { RequestconfigComponent } from '../requestconfig.component';
import { UserService } from '../../../Master/user/user.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { saveAs } from 'file-saver';
import { LocalService } from '../../../local.service';
import {encryptdecrypt} from '../../../encryptdecrypt';
declare var $: any;
@Component({
  selector: 'app-productdetails',
  templateUrl: './productdetails.component.html',
  styleUrls: ['./productdetails.component.css']
})
export class ProductdetailsComponent implements OnInit {
  bsValue = new Date();
  filesUploadModal: BsModalRef;						   
  bsInlineValue = new Date();
  productchildForm: FormGroup;
  outputFormats: Outputformat[] = [];
  dtds: Dtd[] = [];
  types: Type[] = [];
  userid: number;
  Operationtype: string;
  executableFileTypes=[];
  mappedOptFrmts: Outputformat[] = [];
  config: ModalOptions = {
    backdrop: 'static',
    keyboard: false,
    animated: true,
    ignoreBackdropClick: true,
    class: 'modal-dialog-centered'

  }																							 
  productsamedayturnaround: number;
  outputfiles: string;
  uploadbuttonvalue: string;
  product: ConversionrequestDetail = new ConversionrequestDetail();
  productconversionfiledetails: ConversionrequestFileDetail[];
  filedetails: ConversionrequestFileDetail;
  @Input() productdetailsedit :any
  @Input() operation: any;
  @Input() productid: any;
  @Input() productname: any;
  @Input() directorypath: any;
  @Input() viewrequest: any;
  @Input() productList: any;
  @Input() samefilesforall: any;
  @Input() SelectedProducts: any;
  @Input() conversionFiles: any;
  @Input() supportingFiles: any;
  @Input() productmodel: any;
  @Input() proceedconversion = false;
  @Input() fromForm = false;
  @Input() formattachfile: any;
  @Input() samefileforall = false;
  @Input() redirectmodeforproduct: any;
  @Input() emitsamefiles = false;
  @Input() internetdownloadproceedconversion = false;
  @Output() uploadedfiles = new EventEmitter();
  @Input() apiCreatedRequest:any;
  @Input() dbid:any;
  primaryobject: any;
  productlistcount = 0;
  productdesiredcompletiondate: any;
  todayDate = new Date();
  public dpConfig: Partial<BsDatepickerConfig> = new BsDatepickerConfig();
  checkchange = false;
  checkvalue = false;
  @Output() productdetails = new EventEmitter();
  @Output() deletNo = new EventEmitter();
  @Input() dbname: any;
  @Input() requestid: any;
  confirmationpopUp: BsModalRef; message: string = ''; deletingfile: any;
  showuploadFile = true; showprodDetails = false; conversionFileList: any = []; supportingFileList: any = []; ConversionModelShow: boolean = false
  deletelist: any = [];
  Users: any = []; currentuser: any; supportinguser: boolean = false; conversionuser: boolean = true; reqStatusId: number;
  usesamevalueforall = false;
  replaceFilename:string='';
  constructor(private outPutFormatService: OutputformatService, private dtdService: DtdService, private viewContainerRef: ViewContainerRef,
    private typeService: TypeService, private formBuilder: FormBuilder, private dialogService: DialogService,
    private datePipe: DatePipe, private requestConfigService: RequestconfigService, 
    private modalService: BsModalService, private toastr: ToastrService, 
    private resolver: ComponentFactoryResolver, private SpinnerService: NgxSpinnerService, 
    private userservice: UserService, private localService: LocalService ) {

    this.createForm();
    this.getActiveDTD();
    this.getTypeDetails();

    this.dpConfig = {
      isAnimated: true, adaptivePosition: true, containerClass: 'theme-dark-blue', dateInputFormat: 'MM/DD/YYYY'
    }
    //this.userid = + localStorage.getItem("userid");
    this.userid = + this.localService.getJsonValue("userid");
    //this.productchildForm.controls["finaldirectory"].setValue(this.directorypath);
    this.getOutputFormat();
    this.loadusers();
    this.executableFileTypes=[{ 'type': 'exe'}, { 'type': 'sh'},{ 'type': 'js'},{ 'type': 'dll'},
    { 'type': 'bat'},{ 'type': 'bin'},{ 'type': 'job'},{ 'type': 'msi'},{ 'type': 'reg'},{ 'type': 'vb'}];
  }

 async ngOnInit() {
   const currentDate = await this.getCurrentDate();
   this.todayDate = new Date(currentDate);
   this.bsInlineValue = new Date(currentDate);
   
   //if (this.fromForm == true)
   //{
    // this.uploadbuttonvalue = "Edit Uploaded details";
   //}
   //else
   console.log('test by Kalpana');
   console.log(this.apiCreatedRequest);
   console.log(this.conversionFileList);
    if(this.operation == 'edit') {

     this.uploadbuttonvalue = "Edit Uploaded Files";
   }

   else {
     this.uploadbuttonvalue = "Upload Files";
     this.productchildForm.patchValue({
       xmlcontentarea: this.productmodel.xmlcontentarea == null || this.productmodel.xmlcontentarea == undefined ? '' : this.productmodel.xmlcontentarea
     });
    
   }

   if (this.fromForm == true) {
     if (this.formattachfile != '' && this.formattachfile != undefined && this.formattachfile != null) {
       this.formattachfile.forEach((conversiondfiledata, index) => {

         var result = this.conversionFileList.filter(item =>
           Object.keys(item).some(k => item[k] != null &&
             item[k].toString().toLowerCase()
             .includes(conversiondfiledata.filename.toLowerCase()))
         );
         if (result.length == 0) {

           let name = conversiondfiledata.filename;
           let splitname = name.split('.');
           if (splitname.length > 1) {
             splitname.splice(splitname.length - 1, 1);
           }

           this.conversionFileList.push({
             'name': conversiondfiledata.filename,
             'conversionrequestfiledetailid': 0,
             'active': 1,
             'id': conversiondfiledata.filename + '_' + index,
             'conversionfilefrom': 'form',
            'desiredfilename': splitname.join('.')
           });
         }
       });
     }

     for (var i = 0; i < this.conversionFileList.length; i++) {
       this.conversionFileList[i]['filetype'] = 'forConversion'
       this.uploadedFilesList.push(this.conversionFileList[i])
     }
   }
   
   //this.productList.forEach((data, i) => {
   //   if (data.productid == this.productid) {
   //     this.selectedProd = data;
   //     //this.SelectedProducts.
   //   }
   // })
    //if (this.SelectedProducts.length > 1 && this.samefilesforall == true) {
    //  //
    //  this.conversionFileList = this.conversionFiles;
    //  this.supportingFileList = this.supportingFiles;
    //}
  }

  async getCurrentDate() {
    return await this.requestConfigService.GetServerDate().toPromise().then(res => res.date);
  }
 
 
  OpemModal(template: TemplateRef<any>, fileuploadoperation) {
    this.Operationtype = fileuploadoperation;
    this.filesUploadModal = this.modalService.show(template, this.config);
    this.showprodDetails = false;
    this.showuploadFile = true;
    this.uploadedFilesList = [];
    //if (this.operation == 'edit') {

      for (var i = 0; i < this.conversionFileList.length; i++) {        
        this.conversionFileList[i]['filetype'] = 'forConversion'
        this.uploadedFilesList.push(this.conversionFileList[i])
      }
      for (var i = 0; i < this.supportingFileList.length; i++) {
        this.supportingFileList[i]['filetype'] = 'forSupporting'
       // this.supportingFileList[i]['active'] = 1;
        this.uploadedFilesList.push(this.supportingFileList[i])
      }
    this.usesamevalueforall = this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].viewContainerParent.component.requestConfigForm.value.samefileforall;

    const aa = document.getElementsByClassName('modal-content');
    aa[0].classList.remove("modal-content");
    //}
  }

  RemoveFile(item, filetype, callfrom: any) {


    this.deletingfile = item
    if (callfrom == 'component') {
      let showpopup = this.dialogService.addDialog(CommondialogComponent,
        {
          title: 'Please Confirm',
          message: 'Are you sure want to delete this file ' + item.name + '?',
          hclass: 'modelsuccess',
          oktext: 'Yes',
          canceltext: 'No',
          okshow: true,
          cancelshow: true

        }).subscribe((isConfirmed) => {
          if (isConfirmed) {
            this.filesidchange();
            this.removeFiles(filetype, item);

          }
          else {
            this.confirmationpopUp.hide();
          }
        });
    }
    else {
      this.deletingfile = item
      this.confirmationpopUp = this.modalService.show(callfrom, this.config);
      this.message = 'Are you sure want to delete this file ' + item.name + '?';
      const aa = document.getElementsByClassName('modal-content');
      aa[1].classList.remove("modal-content");

    }
  }
 
  removeFiles(type, item) {

    if (type == 'conversiontype') {

      if (this.operation != 'edit') {
        let index = this.conversionFileList.findIndex(cfile => cfile.name == item.name);
        if (index >= 0) {
          this.conversionFileList.splice(index, 1);
        }
      } else {
        let index = this.conversionFileList.findIndex(cfile => cfile.name == item.name);
        if (index >= 0) {
          if (this.conversionFileList[index].conversionrequestfiledetailid == 0) {
            this.conversionFileList.splice(index, 1);
          } else {
            this.conversionFileList[index].active = 0;
          }

        }
      }



      // this.conversionFileList = this.conversionFileList.filter(cfile => cfile.name !== item.name);
    }

    if (type == 'supportingtype') {

      if (this.operation != 'edit') {
        let index = this.supportingFileList.findIndex(cfile => cfile.name == item.name);
        if (index >= 0) {
          this.supportingFileList.splice(index, 1);
        }
      } else {
        let index = this.supportingFileList.findIndex(cfile => cfile.name == item.name);
        if (index >= 0) {
          //if (this.supportingFileList[index].conversionrequestfiledetailid == 0) {
          //  this.supportingFileList.splice(index, 1);
          //} else {
          //  this.supportingFileList[index].active = 0;
          //}
          this.supportingFileList.splice(index, 1);

        }
      }





      // this.supportingFileList = this.supportingFileList.filter(sfile => sfile.name !== item.name);
    }

    if (type == 'uploadfilelist') {


      if (this.operation != 'edit') {
        let index = this.uploadedFilesList.findIndex(cfile => cfile.name == item.name);
        if (index >= 0) {
          this.uploadedFilesList.splice(index, 1);
        }
      } else {
        let index = this.uploadedFilesList.findIndex(cfile => cfile.name == item.name);
        if (index >= 0) {
          if (this.uploadedFilesList[index].conversionrequestfiledetailid == 0) {
            this.uploadedFilesList.splice(index, 1);
          } else {
            this.uploadedFilesList[index].active = 0;
          }

        }
      }
      // this.uploadedFilesList = this.uploadedFilesList.filter(ufile => ufile.name != item.name);
    }
    this.confirmationpopUp.hide();
  }

  ReplaceFile(item, filetype, callfrom: any){
   if($('#productsdetailsreplacefileupload').val() =='' || 
  $('#productsdetailsreplacefileupload').val() == undefined){
  this.toastr.error('Please upload the file to replace');    
    return;
}
if(this.replaceFilename !=''){
  
  var _inputData = [];
  _inputData.push(
    {
      'p_filename': this.replaceFilename,
      'p_conversionrequestfiledetailid': item.conversionrequestfiledetailid,
      'p_conversionrequestid': this.requestid,
      'p_modifiedby': this.userid
    })
    var index=this.conversionFileList.length+1;
    const formData = new FormData();
    formData.append('filenamefromcomponent', this.replaceFilename);
    formData.set('conversionreqattachfile' + index + '*'  + filetype + "*"+this.productid,  $('#productsdetailsreplacefileupload')[0].files[0]);
    formData.append('dbname', this.dbname);
    formData.append('requestdetailid', 'conversionrequest' + ':' + this.requestid.toString());
    formData.append('type', 'edit');
    this.requestConfigService.conversionrequestfileupdate(_inputData[0]).subscribe(
      (res)=>{
        this.requestConfigService.PostFile(formData).subscribe(
          (res) => {
           if (res.body != 0) {
            this.toastr.success("File replace successfully");
            
            console.log(this.uploadedFilesList);
            console.log(this.conversionFileList)
            let index = this.conversionFileList.findIndex(cfile => cfile.name == item.name);
            if (index >= 0) {
            
              this.conversionFileList[index].name=this.replaceFilename;
            }
            this.filesUploadModal.hide();
            this.showuploadFile = true;
            this.showprodDetails = false;
            this.ConversionModelShow = true;
            }
          }, error => {
            this.SpinnerService.hide();
            this.toastr.error("Error while uploading File  during editing");
          });
    });
 

}
}

  filereplaceChangeEvent(eve){
    
    this.replaceFilename = eve.target.files[0].name;   
  }
  proceedtoRemove(type, filetype) {
    if (type == 'yes') {

      //if (filetype == 'conversiontype') {
      //  this.conversionFileList = this.conversionFileList.filter(cfile => cfile.name !== this.deletingfile.name);
      //}
      //if (filetype == 'supportingtype') {
      //  this.supportingFileList = this.supportingFileList.filter(sfile => sfile.name !== this.deletingfile.name);
      //}

      //if (filetype == 'uploadfilelist') {
      //  this.uploadedFilesList = this.uploadedFilesList.filter(ufile => ufile.name != this.deletingfile.name);
      //}
      this.removeFiles(filetype, this.deletingfile);
      this.confirmationpopUp.hide();
    }
    else {
      this.confirmationpopUp.hide();
    }

  }					   																										   																											

  uploadedFilesList: any[] = [];


  fileChangeEvent(event) {
    var fileexist = false; var filename = ''; var filelist = [];var exeFileExists=false; var fileType='';
    for (var i = 0; i < event.target.files.length; i++) {
    var index=  event.target.files[i].name.lastIndexOf('.'); 
    fileType= event.target.files[i].name.substring(index+1)
      var exeExists = this.executableFileTypes.filter(e=>e.type.toLowerCase()===fileType.toString().toLowerCase());
     if(exeExists.length>0){
      exeFileExists=true;
     }
    }
   if(exeFileExists!=true){
    for (var i = 0; i < event.target.files.length; i++) {
      this.uploadedFilesList.forEach((upfile, ind2) => {
        if (event.target.files[i].name == upfile.name && upfile.active == 1) {
          fileexist = true;
          
          if (filename == '')
            filename = upfile.name;
          else
            filename = filename + ' , ' + upfile.name;         
        }
      });
    }   
   
    for (var i = 0; i < event.target.files.length; i++) {
      if (filename.search(event.target.files[i].name) == -1) {
        event.target.files[i]['id'] = event.target.files[i].name + '_' + i;
        event.target.files[i]['productid'] = this.productid;
        event.target.files[i]['active'] = 1;
        event.target.files[i]['conversionrequestfiledetailid'] = 0;
        event.target.files[i]['active'] = 1;
        event.target.files[i]['conversionfilefrom'] = 'upload';
        event.target.files[i]['apirequestfile'] =0;
        
        this.uploadedFilesList.push(event.target.files[i])
      }
    }


    if (fileexist != false) {
      this.toastr.warning('Already files exists. File Name(s): ' + filename );
    }
  } else{
    this.toastr.error( fileType+' files are not allowed to upload');
    $('#productsdetailsfileupload').val('');
    return;
    
  } 
  }

  changeDtd(data, event) {
    this.conversionFileList.forEach((f, i) => {


      if (data.conversionrequestfiledetailid != 0 && data.conversionrequestfiledetailid != null && data.conversionrequestfiledetailid != undefined) {
        if (f.conversionrequestfiledetailid == data.conversionrequestfiledetailid) {

          if (event.currentTarget.options[event.target.selectedIndex].text == 'Select DTD')
            f['dtdname'] = '';
          else
            f['dtdname'] = event.currentTarget.options[event.target.selectedIndex].text;

          f['dtdid'] = +event.currentTarget.value;
        }
      } else {
        if (f.id == data.id) {
          if (event.currentTarget.options[event.target.selectedIndex].text == 'Select DTD')
            f['dtdname'] = '';
          else
            f['dtdname'] = event.currentTarget.options[event.target.selectedIndex].text;

          f['dtdid'] = +event.currentTarget.value;
        }

      }



      // if (this.operation == 'edit') {
      //   if (f.conversionrequestfiledetailid == data.conversionrequestfiledetailid) {
      //     f['dtdname'] = event.currentTarget.options[event.target.selectedIndex].text;
      //     f['dtdid'] = +event.currentTarget.value.replace('"', '').split(':')[0];
      //   }
      // } else {
      //   if (f.id == data.id) {
      //     f['dtdname'] = event.currentTarget.options[event.target.selectedIndex].text;
      //     f['dtdid'] = +event.currentTarget.value.replace('"', '').split(':')[0];
      //   }
      // }
    });
  }
  changeOptFrmt(data, event) {

    this.conversionFileList.forEach((f, j) => {


      if (data.conversionrequestfiledetailid != 0 && data.conversionrequestfiledetailid != null && data.conversionrequestfiledetailid != undefined) {
        if (f.conversionrequestfiledetailid == data.conversionrequestfiledetailid) {
          if (event.currentTarget.options[event.target.selectedIndex].text == 'Select OutFormats')
            f['outputformat'] = '';
          else
            f['outputformat'] = event.currentTarget.options[event.target.selectedIndex].text;

          f['outputformatid'] = +event.currentTarget.value;
        }
      } else {
        if (f.id == data.id) {
          if (event.currentTarget.options[event.target.selectedIndex].text == 'Select OutFormats')
            f['outputformat'] = '';
          else
            f['outputformat'] = event.currentTarget.options[event.target.selectedIndex].text;

          f['outputformatid'] = +event.currentTarget.value;
        }
      }


      // if (this.operation == 'edit') {
      //   if (f.conversionrequestfiledetailid == data.conversionrequestfiledetailid) {
      //     f['outputformat'] = event.currentTarget.options[event.target.selectedIndex].text;
      //     f['outputformatid'] = +event.currentTarget.value.replace('"', '').split(':')[1];
      //   }
      // } else {
      //   if (f.id == data.id) {
      //     f['outputformat'] = event.currentTarget.options[event.target.selectedIndex].text;
      //     f['outputformatid'] = +event.currentTarget.value.replace('"', '').split(':')[1];
      //   }
      // }
    });
  }
  desiredfilenamefocusout(data, event) {
    this.conversionFileList.forEach((f, i) => {

      if (data.conversionrequestfiledetailid != 0 && data.conversionrequestfiledetailid != null && data.conversionrequestfiledetailid != undefined) {
        if (f.conversionrequestfiledetailid == data.conversionrequestfiledetailid) {
          f['desiredfilename'] = event.currentTarget.value;
        }
      } else {
        if (f.id == data.id) {
          f['desiredfilename'] = event.currentTarget.value;
        }
      }


      // if (this.operation == 'edit') {
      //   if (f.conversionrequestfiledetailid == data.conversionrequestfiledetailid) {
      //     f['desiredfilename'] = event.currentTarget.value;
      //   }
      // } else {
      //   if (f.id == data.id) {
      //     f['desiredfilename'] = event.currentTarget.value;
      //   }
      // }

    });

  }



  CompleteDetails(template: TemplateRef<any>) {



    let count = 0;
    this.conversionFileList.forEach(element => {
      if (element.active == 1 && element.desiredfilename != null && element.desiredfilename != undefined) {
        let slash = element.desiredfilename.indexOf('/');
        let backslash = element.desiredfilename.indexOf('\\');
        let colon = element.desiredfilename.indexOf(':');
        let pipe = element.desiredfilename.indexOf('|');
        let star = element.desiredfilename.indexOf('*');
        let questionmark = element.desiredfilename.indexOf('?');
        let doublequote = element.desiredfilename.indexOf('"');
        let greater = element.desiredfilename.indexOf('>');
        let lesser = element.desiredfilename.indexOf('<');
        if (slash !== -1 || backslash !== -1 || colon !== -1 || pipe !== -1 || star !== -1 || questionmark !== -1 || doublequote !== -1 || greater !== -1 || lesser !== -1 ) {
          count++;
        }
      }
    });
    if (count > 0) {
      this.toastr.warning('Desired file name does not contains these characters(/\\ :*?"<>|)');
      return;
    }

    this.conversionFileList.forEach(element => {
      if (element.active == 1 && (element.desiredfilename == '' || element.desiredfilename == null || element.desiredfilename == undefined) && element.isprimary != false) {
        let name = element.name;
        let splitname = name.split('.');
        if (splitname.length > 1) {
          splitname.splice(splitname.length - 1, 1);
        }
        element.desiredfilename = splitname.join('.');
      }
    });

    let samedesiredfilename = [];
    this.conversionFileList.forEach(element => {
      if (element.desiredfilename != '' && element.desiredfilename != undefined && element.desiredfilename != null) {
        var a = this.conversionFileList.filter(x => x.desiredfilename == element.desiredfilename && x.outputformatid == element.outputformatid && x.active == 1 && element.active == 1);
        if (a.length > 1) {
          samedesiredfilename.push(element.desiredfilename);
        }
      }

    });
    if (samedesiredfilename.length > 0) {
      this.toastr.warning('File(s) desired name must be unique');
      return;
    }

    this.filesUploadModal.hide();
    this.showuploadFile = true;
    this.showprodDetails = false;
    this.ConversionModelShow = true;
    // var f = this.getParentComponent();

    if (this.checkchange) {
      this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].viewContainerParent.component.samefilechange(this.usesamevalueforall, this.productid);
      this.checkchange = false;
    }
    this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].viewContainerParent.component.fileuploadedproduct = this.productid;

    if (this.emitsamefiles && this.usesamevalueforall) {

      this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].viewContainerParent.component.entry.forEach(container => {
        let containerid = container.viewContainerRef.element.nativeElement.id;
        //if (containerid != this.productid) {
          if (container.viewContainerRef !== undefined) {
            if (container.viewContainerRef['_embeddedViews'].length != 0) {
              for (let i = 0; i < container.viewContainerRef['_embeddedViews'].length; i++) {
                var conversionFileListtmp = this.conversionFileList;
                var supportingFileListtmp = this.supportingFileList;
                var uploadedFilesListtmp = this.uploadedFilesList;

                if (container.viewContainerRef['_embeddedViews'][i].nodes[1].instance['productid'] != this.productid) {
                  if (container.viewContainerRef['_embeddedViews'][i] != undefined && container.viewContainerRef['_embeddedViews'][i] != undefined) {
                    container.viewContainerRef['_embeddedViews'][i].nodes[1].instance['conversionFileList'] = conversionFileListtmp;
                    container.viewContainerRef['_embeddedViews'][i].nodes[1].instance['supportingFileList'] = supportingFileListtmp;
                    container.viewContainerRef['_embeddedViews'][i].nodes[1].instance['uploadedFilesList'] = uploadedFilesListtmp;
                  }
                }
              }
            }
          }
        //}
      });
    }



  }

  
  filetypechange(item, event) {

    for (var i = 0; i < this.uploadedFilesList.length; i++) {
      if (this.uploadedFilesList[i].name == item.name && this.uploadedFilesList[i].active == 1) {
        if (this.uploadedFilesList[i].conversionrequestfiledetailid == 0) {
          this.uploadedFilesList[i]['filetype'] = event.currentTarget.value;
          this.uploadedFilesList[i]['conversionrequestfiledetailid'] = 0;
          this.uploadedFilesList[i]['conversionfilefrom'] = 'upload';
          this.uploadedFilesList[i]['desiredfilename'] = '';

        } else {
          let itemvalue = JSON.parse(JSON.stringify(item));

          this.uploadedFilesList[i].active = 1;
          this.uploadedFilesList[i].filetype = event.currentTarget.value;
          this.uploadedFilesList[i].desiredfilename = '';
          this.uploadedFilesList[i].dtdname = '';
          this.uploadedFilesList[i].dtdid = 0;
          this.uploadedFilesList[i].outputformat = '';
          this.uploadedFilesList[i].outputformatid = 0;



          itemvalue.active = 0;
          this.uploadedFilesList.push(itemvalue);
        }

      }

    }
  }


 

  movetoProductDetails(data) {

    if (this.uploadedFilesList.length > 0) {
      var count = 0;// var filetypearray=[]
      // var obj = {};
      //this.conversionFileList.forEach((d, i) => {
      //  $("#ddlproduct_dtd_" + i + " option:contains(" + d.dtdname + ")").attr('selected', 'selected');
      //  $("#ddlproduct_optfrmt_" + i + " option:contains(" + d.outputformat + ")").attr('selected', 'selected');
      //  $("#prddesiredfilename_" + i).val(d.desiredfilename);
      //});

      // this.conversionFileList = [];
      // this.supportingFileList = [];
      if (data == 'next') {
        this.uploadedFilesList.forEach(item => {
          if (!item.hasOwnProperty("filetype")) {
            count++;
          }
        });

        // $.each($("table#confileuploadtbl tr input[type=radio]"), function (a, b) {

        //  var chkname = $(this).prop("name");
        //  //if (chkname=='')
        //  var s = $('table#confileuploadtbl input[name =' + chkname + ']:checked')

        //  if (s.length <= 0)
        //    count++;


        //  //this.uploadedFilesList
        //    //filetypearray.push(s[0].value)

        // })



        if (count == 0) {

          this.conversionFileList = this.uploadedFilesList.filter(item => item.filetype === 'forConversion');
          this.supportingFileList = this.uploadedFilesList.filter(item => item.filetype === 'forSupporting');
          let conversionfileactivelist = this.conversionFileList.filter(x => x.active == 1);
          if (conversionfileactivelist.length > 0) {
            this.showuploadFile = false;
            this.showprodDetails = true;
          } else {
            this.toastr.warning('Please select atleast one conversion file');
          }

          if (data == 'next') {
            let getprimaryfile = this.conversionFileList.filter(s => s.isprimary == true && s.active==1);
            if (getprimaryfile.length > 0) {
              this.conversionFileList.forEach(element => {
                if (element.isprimary != true) {
                  element.isprimary = false;
                }
              });
            } else {
              this.conversionFileList.forEach(element => {
                element.isprimary = null;
              });
            }
          }

          if (this.mappedDtds.length > 0 && data == 'next') {
            this.conversionFileList.forEach((d, i) => {
              if (d.dtdname == undefined || d.dtdname == null) {
                d['dtdname'] = this.mappedDtds[0].dtd;
                d['dtdid'] = this.mappedDtds[0].dtdid;
              }

            });
          }
          else {
            this.conversionFileList.forEach((d, i) => {
              if (d.dtdname == undefined || d.dtdname == null || d.dtdname == '') {
                d['dtdname'] = '';
                d['dtdid'] = 0;
              }
            });
          }

          if (this.mappedOptFrmts.length > 0 && data == 'next') {
            this.conversionFileList.forEach((d, i) => {
              if (d.outputformat == undefined || d.outputformat == null) {
                d['outputformat'] = this.mappedOptFrmts[0].outputformat;
                d['outputformatid'] = this.mappedOptFrmts[0].outputformatid;
              }

            });
          }
else {
            this.conversionFileList.forEach((d, i) => {
              if (d.outputformat == undefined || d.outputformat == null || d.outputformat == '') {
                d['outputformat'] = '';
                d['outputformatid'] = 0;
              }
            });
          }
        } else {
          this.toastr.warning('please selece all files for conversion or supporting');
        }

      } else if (data == 'prev') {

        this.showuploadFile = true;
        this.showprodDetails = false;
      }


      // console.log(this.uploadedFilesList);

    } else {
      this.toastr.warning('Please upload any file');
    }

  }
 
 
  getproductdetails():any {  
    var outputformat = [];     
  
    $.each($('div#' + 'outputformatDiv input[type=radio]'), function (a, b) {
      var obj = {};
      if ($(this).prop("checked") == true) {
        obj['name'] = $(this).attr("value")
        obj['value'] = $(this).prop("checked") == true ? 1 : 0
        outputformat.push(obj)
      }
    })




    this.outputfiles = JSON.stringify(outputformat);  
    if (this.productchildForm.controls["productsamedayturnaround"].value == false)
      this.productsamedayturnaround = 0;
    else
      this.productsamedayturnaround = 1;
   
     this.product.productid= this.productid;
    //this.product.productdesiredcompletiondate= this.productchildForm.controls["productdesiredcompletiondate"].value;
     this.product.productdesiredcompletiondate = this.datePipe.transform(this.productchildForm.controls["productdesiredcompletiondate"].value, "MM/dd/yyyy");
     //this.product.desiredfilename = this.productchildForm.controls["desiredfilename"].value;
     // this.directorypath = this.productchildForm.controls["finaldirectory"].value;
      this.product.finaldirectory=this.productchildForm.controls["finaldirectory"].value;
   // this.product.type=this.productchildForm.controls["type"].value;
   //this.product.outputfiles=this.outputfiles;
   //this.product.dtdname=this.productchildForm.controls["dtdname"].value;
      this.product.xmlcontentarea=this.productchildForm.controls["xmlcontentarea"].value;
      this.product.productsamedayturnaround=this.productsamedayturnaround;
   //this.product.specifyothers = this.productchildForm.controls["specifyothers"].value;
    //this.product.productdesiredcompletiondate = this.productchildForm.controls["productdesiredcompletiondate"].value;
  //this.product.conversioneditorscomment = this.productchildForm.controls["conversioneditorscomment"].value;
      this.product.numberofhours = this.productchildForm.controls["numberofhours"].value != '' ? this.productchildForm.controls["numberofhours"].value:0; 
   // if (this.SelectedProducts.length > 1 && this.samefilesforall == true) {
    this.product.conversioneditorscomment = this.productchildForm.controls["conversioneditorscomment"].value;
    this.product.conversionproductname = this.productchildForm.controls['conversionproductname'].value;

       var supportfilename = "";  
    if (this.supportingFileList.length > 0) {
      this.supportingFileList.forEach(supporting => {
        if (supporting.active == 1) {

          if (supportfilename == '')
            supportfilename = supporting.name;
          else
            supportfilename = supportfilename + ':' + supporting.name;
        }
        });
    
       }
    this.product.supportingfiles = supportfilename; 
    this.product.productfiledetails = this.getproductfiledetails();



    return this.product;
  }


  getproductfiledetails(): any {
    this.filesidchange();
    this.productconversionfiledetails = [];   
    if (this.conversionFileList.length > 0) {
      this.conversionFileList.forEach(conversion => {
        var outputfile = [];
        if (conversion.outputformat != '' && conversion.outputformat != undefined && conversion.outputformat != null) {    
          var obj = {};
          obj['name'] = conversion.outputformat;
          obj['value'] = 1;
          outputfile.push(obj);
        }
        this.filedetails = new ConversionrequestFileDetail();
        this.filedetails.desiredfilename = conversion.desiredfilename;
        this.filedetails.outputfiles = JSON.stringify(outputfile);
        this.filedetails.dtdname = conversion.dtdid == undefined || conversion.dtdid == null ? 0 : conversion.dtdid;
        this.filedetails.conversionfiles = conversion.name;
        this.filedetails.conversionrequestfiledetailid = conversion.conversionrequestfiledetailid;
        this.filedetails.active = conversion.active;
        this.filedetails.isprimary = conversion.isprimary == null ? null : JSON.stringify(conversion.isprimary);
        this.filedetails.conversionfilefrom = conversion.conversionfilefrom;
        this.productconversionfiledetails.push(this.filedetails);
      });
    }
    return this.productconversionfiledetails;
  }

  getproductfiles(): any {

   
  return this.uploadedFilesList;
  }

  createForm() {
    this.productchildForm = this.formBuilder.group({
      product: ['', Validators.required],
      productid: ['', Validators.required],
      productdesiredcompletiondate: ['',Validators.required],
      desiredfilename: ['', Validators.required],
      finaldirectory: ['', Validators.required],
      type: [0, Validators.required],
      outputfiles: [0, Validators.required],
      dtdname: [0, Validators.required],
      xmlcontentarea: ['', Validators.required],
      productsamedayturnaround: [false, Validators.required],    
      specifyothers: ['', Validators.required],
      conversioneditorscomment: ['Please provide the below information if you are not uploading a file - \nDesired Filename: \nDTD: \nOutput Type: \n ', Validators.required], numberofhours: [0],
      conversionproductname: ['']
    });  
  }



  getOutputFormat() {
    this.outPutFormatService.GetActiveFormats().subscribe(res => {
      this.outputFormats = res;

      this.outputFormats = this.outputFormats.filter(
        item => item.active === 1);

      var selectedProdOptFrmt = JSON.parse(this.productmodel.outputformatid);
      if (selectedProdOptFrmt) {
      selectedProdOptFrmt = selectedProdOptFrmt.outputformatid
     
        this.outputFormats.forEach((optfrmt, i) => {
           selectedProdOptFrmt.forEach((seloptft, k) => {
            if (optfrmt.outputformatid == seloptft.outputformatid) {
          this.mappedOptFrmts.push(optfrmt)
            }
           })
        });
      }																	 
      this.productchildForm.patchValue({
        conversionproductname: this.productmodel.productname
      });

      if (this.operation == 'edit') {
        //var a = '';
        //this.outputFormats.forEach(output => {
        //  a = 'false';
        //  for (let item of this.productdetailsedit[0].outputfiles) {
        //    if (item.name == output.outputformat && item.value == 1) {
        //      a='true'
        //      break;
        //    }
        //  }
        //  if (a == 'true') 
        //    output["checked"] = true;
        //  else
        //    output["checked"] = false;
        //})
         this.productchildForm.controls["productdesiredcompletiondate"].setValue(this.productdetailsedit[0].productdesiredcompletiondate);
         this.productchildForm.controls["desiredfilename"].setValue(this.productdetailsedit[0].desiredfilename);
         this.productchildForm.controls["finaldirectory"].setValue(this.productdetailsedit[0].finaldirectory);
       // this.productchildForm.controls["type"].setValue(this.productdetailsedit[0].type);
       // this.productchildForm.controls["dtdname"].setValue(this.productdetailsedit[0].dtdname);
         this.productchildForm.controls["xmlcontentarea"].setValue(this.productdetailsedit[0].xmlcontentarea);
       // this.productchildForm.controls["specifyothers"].setValue(this.productdetailsedit[0].specifyothers);
        //this.productchildForm.controls["conversioneditorscomment"].setValue(this.productdetailsedit[0].conversioneditorscomment);
         this.productchildForm.controls["numberofhours"].setValue(this.productdetailsedit[0].numberofhours);
        this.productchildForm.controls["conversioneditorscomment"].setValue(this.productdetailsedit[0].conversioneditorscomment);
        let productname = this.productdetailsedit[0].conversionproductname;
        this.productchildForm.patchValue({
          conversionproductname: productname == null || productname == undefined ? this.productmodel.productname : productname
        });

        this.reqStatusId = this.productdetailsedit[0].statusid;
        var supportingfileedit = this.productdetailsedit[0].supportingfiles;
        var conversionfileedit = this.productdetailsedit[0].conversionfiledetails;

        if (supportingfileedit != '' && supportingfileedit != undefined && supportingfileedit != null ) {
          let a = supportingfileedit.split(':')
          a.forEach(data => {
            this.supportingFileList.push({ 'name': data, 'active': 1 });
          });
        }


        if (conversionfileedit != '' && conversionfileedit != undefined && conversionfileedit != null) {


          conversionfileedit.forEach(conversiondfiledata => {

            var result = this.conversionFileList.filter(item =>
              Object.keys(item).some(k => item[k] != null &&
                item[k].toString().toLowerCase()
                .includes(conversiondfiledata.conversionfiles.toLowerCase()))
            );


            if (result.length == 0) {
              this.conversionFileList.push({
                'name': conversiondfiledata.conversionfiles,
                'desiredfilename': conversiondfiledata.desiredfilename,
                'dtdname': conversiondfiledata.dtdnamevalue,
                'outputformat': conversiondfiledata.outputfilename,
                'outputformatid': this.getoutputformatid(conversiondfiledata.outputfilename),
                'dtdid': conversiondfiledata.dtdname,
                'conversionrequestfiledetailid': conversiondfiledata.conversionrequestfiledetailid,
                'active': conversiondfiledata.active,
                'conversionfilefrom': conversiondfiledata.conversionfilefrom,
                'isprimary': conversiondfiledata.isprimary == null ? null : JSON.parse(conversiondfiledata.isprimary),
             'apirequestfile':conversiondfiledata.apirequestfile
              });
            }

          });



        }



        for (var i = 0; i < this.conversionFileList.length; i++) {
          this.conversionFileList[i]['filetype'] = 'forConversion'
          this.uploadedFilesList.push(this.conversionFileList[i])
        }
        for (var i = 0; i < this.supportingFileList.length; i++) {
          this.supportingFileList[i]['filetype'] = 'forSupporting'
          this.uploadedFilesList.push(this.supportingFileList[i])
        }


         if (this.productdetailsedit[0].productdesiredcompletiondate != null)
          this.bsValue = new Date(this.productdetailsedit[0].productdesiredcompletiondate);

         if (this.productdetailsedit[0].productsamedayturnaround == 1)
          this.productchildForm.controls['productsamedayturnaround'].setValue(true);
         else {
          this.productchildForm.controls['productsamedayturnaround'].setValue(false);
         }
      }


      if (this.viewrequest == true) {
        setTimeout(function () {
        $('input').keypress(function (event) {
        //  alert('Hi');
          if (event.keyCode === 8 || event.keyCode === 46) {
         //   alert('Hi12');
        //    event.preventDefault();
          }
        });
      }, 3000);

        $('textarea').keypress(function (event) {
          if (event.keyCode === 8 || event.keyCode === 46) {
            event.preventDefault();
          }

          event.preventDefault();
        });

      }		
     
    }, err => {
     
    })
  }
 selectedProd: any; mappedDtds: Dtd[] = [];
  getActiveDTD() {
    this.dtdService.GetActive().subscribe(res => {
      this.dtds = res;

      this.dtds = this.dtds.filter(
        item => item.active === 1);

      var selectedProdDtd = JSON.parse(this.productmodel.dtdid);
      if (selectedProdDtd) {
        selectedProdDtd = selectedProdDtd.dtdid
        this.dtds.forEach((dtd, j) => {
           selectedProdDtd.forEach((seldtd, k) => {
           if (dtd.dtdid == seldtd.dtdid) {
          this.mappedDtds.push(dtd);
           }
          })
        });
      }
    },
      error => {
      })
  }
  getTypeDetails() {
    this.typeService.Get().subscribe(res => {
      this.types = res
      this.types = this.types.filter(
        item => item.active === 1);

    }, err => {
      
    })
  }

  specifyOthersChange(event) {
    if (event.currentTarget.checked) {

      $('#divothers' + this.productid).css('display', 'block');
    }
    else {
      $('#divothers' + this.productid).css('display', 'none');
    }
  }



  checksamedataturnarround() {
    var todayDate = this.datePipe.transform(new Date(this.todayDate), "dd/MM/yyyy");   
    var selDate = this.datePipe.transform(this.productchildForm.controls["productdesiredcompletiondate"].value, "dd/MM/yyyy");
   //var todaydate = new Date("MM/DD/YYYY");
   //var selecteddate = new Date(this.productchildForm.controls["productdesiredcompletiondate"].value;
    if (todayDate == selDate)
      this.showPopUpforconfirm();
    else
      this.productchildForm.controls['productsamedayturnaround'].setValue(false);
    
  }

  desiredCompDateChange(event, datectrlid, id, cntrlname, index?) {

    //if (this.check == true) {

    //  this.counter = this.counter + 1;
    //  if (this.counter >= 3 && event.length != 0) {
    //    if (event.toString() === 'Invalid Date') {
    //      //  this.toastr.warning('Please select Appropriate date')
    //      return
    //    }
    //    var todayDate = this.datePipe.transform(this.bsInlineValue, "dd/MM/yyyy");
    //    //console.log(a)
    //    var selDate = this.datePipe.transform(event, "dd/MM/yyyy");
    //    if (todayDate === selDate) {
    //      if (cntrlname == "datecontrollerproduct") {
    //        if ($('#' + id + index).prop('checked') === false) {
    //          this.showPopUp(event, datectrlid + index, id + index, cntrlname)
    //        }
    //      }
    //      else {
    //        if ($('#' + id).prop('checked') === false) {
    //          this.showPopUp(event, datectrlid, id, cntrlname)
    //        }
    //      }



    //    }
    //    else {
    //      if (cntrlname == "datecontrollerproduct") {
    //        $('#' + id + index).prop('checked', false)
    //      }
    //      else {
    //        $('#' + id).prop('checked', false)
    //      }
    //    }
    //  }
    //}
  }

  samedaychange(event) {
    
    if (event.currentTarget.checked) {
      this.showPopUpforconfirm();
    }
    else {
      this.productchildForm.controls['numberofhours'].setValue(0);
      var todayDate = this.datePipe.transform(new Date(this.todayDate), "dd/MM/yyyy");
      var selDate = this.datePipe.transform(this.productchildForm.controls["productdesiredcompletiondate"].value, "dd/MM/yyyy");


      //var todaydate = new Date("MM/DD/YYYY");
      //var selecteddate = new Date(this.productchildForm.controls["productdesiredcompletiondate"].value;
      if (todayDate == selDate)
        this.bsValue = null;

    }
    $('#productsamedayturnaround' + this.productid).prop('checked', event.currentTarget.checked);
  }

  showPopUpforconfirm() {

    let showpopup = this.dialogService.addDialog(CommondialogComponent,
      {
        title: 'Please Confirm',
        message: 'Same day turnaround will incur additional cost. Are you sure you want to continue?',
        hclass: 'modelsuccess',
        oktext: 'Yes',
        canceltext: 'No',
        okshow: true,
        cancelshow: true
      }).subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.productchildForm.controls['productsamedayturnaround'].setValue(true);
          $('#productsamedayturnaround' + this.productid).prop('checked', true);
          this.bsValue = new Date(this.todayDate);
        }
        else {
          this.productchildForm.controls['productsamedayturnaround'].setValue(false);
          $('#productsamedayturnaround' + this.productid).prop('checked', false);
          this.bsValue = null;
        }

      });
  }
  fileDownloadrequest(filename, type) {
    this.SpinnerService.show();
    let requestData: any = [];
    requestData.push({
      'requesttype': 'conversionrequest', 'dbname': this.dbname, 'requestid': this.requestid, 'fileName': filename, 'type': type
    });

    this.requestConfigService.DownloadFileRequestWithSpecialCharacters(requestData[0]).subscribe(res => {
      let objectURL = 'data:application/octet-stream;base64,' + res.body.file;
      saveAs(objectURL, filename);
      this.SpinnerService.hide();
    },
      error => {
        this.toastr.error('File not found');
        this.SpinnerService.hide();
      });

  }


  //showPopUp(event, datectrlid, id, cntrlname) {
  //  let showpopup = this.dialogService.addDialog(CommondialogComponent,
  //    {
  //      title: 'Please Confirm',
  //      message: 'Additional cost will be applied...Do you Want to Continue..?',
  //      hclass: 'modelsuccess',
  //      oktext: 'Yes',
  //      canceltext: 'No',
  //      okshow: true,
  //      cancelshow: true
  //    }).subscribe((isConfirmed) => {
  //      if (isConfirmed) {
         
  //        if (cntrlname === 'datecontrollerproduct') {
  //          $('#' + id).prop('checked', true)
  //          //this.requestConfigForm.controls[id].setValue(this.bsInlineValue);
  //        }
         
         
  //      }
  //      else {
          
  //        if (cntrlname === 'checkboxcontrollerproduct') {
  //          //this.requestConfigForm.controls[id].setValue(this.bsInlineValue);
  //          $('#' + id).prop('checked', false)
  //        }
         
  //      }

  //    });
  //}
  loadusers() {
    //this.getqueryData();
    //this.userid = +localStorage.getItem("userid");
     let a= new encryptdecrypt();
    this.userid = +this.localService.getJsonValue("userid");
    this.userservice.Get().toPromise().then(res => {
       res.forEach((data: any) => {
        data.firstname = a.decryptUsingAES256(data.firstname);
        data.lastname = a.decryptUsingAES256(data.lastname);
        data.emailid = a.decryptUsingAES256(data.emailid);
      });

      this.Users = res;
      this.currentuser = this.Users.find(y => y.userid == this.userid);
      //var userdata = this.UserList;
      if (this.currentuser) {
        if (this.currentuser.reviewmapped) {
          var reviewmapped = JSON.parse(this.currentuser.reviewmapped);
          if (reviewmapped.reviewmapped.length) {
            this.supportinguser = true;
          }

        }
        if (this.currentuser.requestmapped) {

          var requestmapped = JSON.parse(this.currentuser.requestmapped);
          if (requestmapped.requestmapped.length) {
            this.conversionuser = true;
          }

        }
      }

    })
  }
  //primaryFileChange(item, event) {
  //  this.conversionFileList.forEach(element => {
  //    element['isprimary'] = false;
  //    element['dtdname'] = '';
  //    element['dtdid'] = 0;
  //    element['outputformat'] = '';
  //    element['outputformatid'] = 0;
  //    element['desiredfilename'] = '';
  //  });
  //  this.conversionFileList.forEach(element => {
  //    // tslint:disable-next-line: max-line-length
  //    if (item.conversionrequestfiledetailid != 0 && item.conversionrequestfiledetailid != null && item.conversionrequestfiledetailid != undefined) {
  //      if (element.conversionrequestfiledetailid == item.conversionrequestfiledetailid) {
  //        element.isprimary = true;
  //      }
  //    } else {
  //      if (element.id == item.id) {
  //        element.isprimary = true;
  //      }
  //    }
  //  });

  //}


  //usesamevaluechange(event) {
  //  console.log('event: ', event);
  //  if (this.conversionFileList.length > 0) {
  //    let primary = this.conversionFileList.filter(x => x.isprimary == true);
  //    if (primary.length == 0) {
  //      let filedetail = this.conversionFileList[0];
  //      if (filedetail.desiredfilename != '') {
  //        this.conversionFileList.forEach(element => {
  //          if (element.isprimary == true || element.isprimary == null) {
  //            element.desiredfilename = filedetail.desiredfilename;
  //            element.dtdname = filedetail.dtdname;
  //            element.dtdid = filedetail.dtdid;
  //            element.outputformat = filedetail.outputformat;
  //            element.outputformatid = filedetail.outputformatid;
  //          }
  //        });
  //      }
  //    } else {
  //      this.usesamevalueforall = false;
  //      $('#usesamevalueforall').prop('checked', false);
  //      this.toastr.warning('Primary file is selected.');
  //    }

  //  }
  //}

  primaryFileChange(item, callfrom) {
    this.primaryobject = item;
    this.confirmationpopUp = this.modalService.show(callfrom, this.config);
    this.message = 'Are you sure want to make this file as primary?';
    const aa = document.getElementsByClassName('modal-content');
    aa[1].classList.remove('modal-content');
  }


  primarycheck(isConfirmed) {
    let item = this.primaryobject;
    if (isConfirmed) {
      this.conversionFileList.forEach(element => {
        element['isprimary'] = false;
      });
      this.conversionFileList.forEach(element => {
        if (item.conversionrequestfiledetailid != 0 && item.conversionrequestfiledetailid != null && item.conversionrequestfiledetailid != undefined) {
          if (element.conversionrequestfiledetailid == item.conversionrequestfiledetailid) {
            element.isprimary = true;
          } else {
            element['dtdname'] = '';
            element['dtdid'] = 0;
            element['outputformat'] = '';
            element['outputformatid'] = 0;
            element['desiredfilename'] = '';
          }
        } else {
          if (element.id == item.id) {
            element.isprimary = true;
          } else {
            element['dtdname'] = '';
            element['dtdid'] = 0;
            element['outputformat'] = '';
            element['outputformatid'] = 0;
            element['desiredfilename'] = '';
          }
        }
      });
      this.confirmationpopUp.hide();
    }
    else {
      let nullrecords = this.conversionFileList.filter(x => x.isprimary == null);
      let falserecords = this.conversionFileList.filter(x => x.isprimary == false);

      this.conversionFileList.forEach(element => {
        if (item.conversionrequestfiledetailid != 0 && item.conversionrequestfiledetailid != null && item.conversionrequestfiledetailid != undefined) {
          if (element.conversionrequestfiledetailid == item.conversionrequestfiledetailid) {
            element['isprimary'] = nullrecords.length == 0 ? false : null;
          }
        } else {
          if (element.id == item.id) {
            element.isprimary = nullrecords.length == 0 ? false : null;
          }
        }

      });
      this.confirmationpopUp.hide();
    }
  }


  //usesamevaluechange(event) {
  //  if (this.conversionFileList.length > 0 && event) {
  //    let primary = this.conversionFileList.filter(x => x.isprimary == true);
  //    let usesamedetailvalue = this.conversionFileList.filter(x => x.desiredfilename != '' && x.desiredfilename != undefined && x.desiredfilename != null && x.dtdid > 0 && x.outputformatid > 0);
  //    // let dtdidchanges = this.conversionFileList.filter(x => x.dtdid > 0);
  //    // let outputformatidchanges = this.conversionFileList.filter(x => x.outputformatid > 0);
  //    if (primary.length == 0) {
  //      if (usesamedetailvalue.length == 1) {
  //        // let filedetail = this.conversionFileList[0];
  //        // let filedetail = desiredfilenamechanges[0];

  //        let filedetail = usesamedetailvalue[0];

  //        if (filedetail.desiredfilename != '') {
  //          this.conversionFileList.forEach(element => {
  //            // if (element.isprimary == true || element.isprimary == null) {
  //            element.desiredfilename = filedetail.desiredfilename;
  //            element.dtdname = filedetail.dtdname;
  //            element.dtdid = filedetail.dtdid;
  //            element.outputformat = filedetail.outputformat;
  //            element.outputformatid = filedetail.outputformatid;
  //            // }
  //          });
  //        }
  //      } else {
  //        this.usesamevalueforall = false;
  //        $('#usesamevalueforall').prop('checked', false);
  //        if (usesamedetailvalue.length > 1) {
  //          this.toastr.warning('Give only one file details to copy others');
  //        } else {
  //          this.toastr.warning('Please choose or enter Desired filename, DTD and Output Format for one file ');
  //        }
  //      }

  //    } else {
  //      this.usesamevalueforall = false;
  //      $('#usesamevalueforall').prop('checked', false);
  //      this.toastr.warning('Primary file is selected.');
  //    }

  //  }
  //}

  removeprimary() {
    this.conversionFileList.forEach(element => {
      element.isprimary = null;
    });
  }

  filesidchange() {
    let cfile = this.conversionFileList;
    let sfile = this.supportingFileList;
    let ufile = this.uploadedFilesList;

    this.conversionFileList = [];
    this.supportingFileList = [];
    this.uploadedFilesList = [];

    cfile.forEach(element => {
      element.productid = this.productid;
      this.conversionFileList.push(element);
    });
    sfile.forEach(element => {
      element.productid = this.productid;
      this.supportingFileList.push(element);
    });
    ufile.forEach(element => {
      element.productid = this.productid;
      this.uploadedFilesList.push(element);
    });



  }
  usesamevaluechange(event) {
    this.emitsamefiles = event;
    this.checkchange = true;
    this.checkvalue = !event;
    // this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].viewContainerParent.component.samefilechange(event, this.productid);
  }

  closechange() {
    if (this.checkchange) {
      this.usesamevalueforall = this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].viewContainerParent.component.requestConfigForm.value.samefileforall;
    }
  }

  getoutputformatid(outputformat) {
    let outputformatvalue = this.outputFormats.filter(x => x.outputformat == outputformat);
    if (outputformatvalue.length > 0) {
      return outputformatvalue[0].outputformatid;
    } else {
      return 0;
    }
  }
  omit_special_char(event) {
    var k;
    k = event.charCode;
    return (k != 47 && k != 92 && k != 58 && k != 42 && k != 63 && k != 34 && k != 60 && k != 62 && k != 124 );
  }




}
